import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { adminService } from '@/services/admin';
import { Card } from '@/components/ui/Card';
import { resolvePersonPhoto } from '@/utils/avatars';

export function BestStudentsWidget() {
    const navigate = useNavigate();
    const { data, isLoading } = useQuery({
        queryKey: ['student-rankings', 'best'],
        queryFn: () => adminService.getStudentRankings('best', 5, 'monthly'),
    });

    if (isLoading) return <div className="h-64 bg-slate-50 animate-pulse rounded-xl" />;

    return (
        <Card className="p-6">
            <div className="flex items-center justify-between mb-6">
                <div>
                    <h3 className="text-lg font-bold text-slate-800">Highest attendance</h3>
                    <p className="text-sm text-slate-500">Who is coming this month</p>
                </div>
            </div>

            <div className="space-y-4">
                {data?.map((student: any) => (
                    <button
                        key={student.id}
                        type="button"
                        onClick={() => navigate(`/admin/reports/students/${student.id}`)}
                        className="flex w-full items-center gap-4 rounded-lg border border-slate-100 bg-slate-50 p-3 text-left hover:border-slate-200"
                    >
                        <div className="w-10 h-10 rounded-full bg-slate-100 overflow-hidden flex-shrink-0 border-2 border-white shadow-sm">
                            <img src={resolvePersonPhoto(student, 'student')} alt="" className="w-full h-full object-cover" />
                        </div>
                        <div className="flex-1 min-w-0">
                            <div className="font-semibold text-slate-900 truncate">{student.name}</div>
                            <div className="text-xs text-slate-500">{student.className}</div>
                        </div>
                        <div className="text-right">
                            <div className="text-lg font-bold text-slate-800">{student.attendanceRate}%</div>
                            <div className="text-xs text-slate-500 font-medium">Present</div>
                        </div>
                    </button>
                ))}
                {(!data || data.length === 0) && <div className="text-center text-slate-400 py-4">No attendance recorded yet</div>}
            </div>
        </Card>
    );
}
